<template>
    <div class="dadata-suggestions" :langg="langust" :class="{ is_focus: is_focus, is_changed: is_changed }">
        <input
            ref="input"
            v-model="value"
            type="text"
            class="form-group__input"
            :class="inputClass"
            @blur="checkValue"
            @click="is_focus = true"
            @input="get($event)"
            :disabled="disabled"
            autocomplete="false_disabled_hack@#!@#$" />
        <transition name="fade">
            <div
                class="dadata-suggestions__list text_13"
                v-if="isShowSuggestions && !disabled"
                :class="{ is_empty: !suggestions.length }">
                <div
                    class="dadata-suggestions__item"
                    v-for="(item, index) in suggestions"
                    @click="select(item)"
                    :key="index"
                    v-html="item.value.replace(re, '<mark>$&</mark>')"></div>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "DaDataSuggestions",
    props: {
        resetting: {
            type: Boolean,
            default: false,
        },
        country: {
            type: String,
            default: "",
        },
        inputClass: {
            type: Array,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        initValue: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            suggestions: [],
            is_changed: false,
            is_focus: false,
            query: "",
            timeout: null,
            value: "",
            wasSelected: false,
        };
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
            defaultCountry: "globalvars/getCurrentCountry",
        }),
        re() {
            return new RegExp(this.query, "gi");
        },

        isShowSuggestions() {
            return this.is_focus && this.is_changed;
        },
        options() {
            return {
                count: 10,
                from_bound: { value: "city" },
                language: this.langust == "ru" ? "ru" : "en",
                locations: [{ country: "*", country_iso_code: this.country ? this.country : this.defaultCountry }],
                locations_boost: [],
                query: "",
                to_bound: { value: "settlement" },
            };
        },
    },
    watch: {
        resetting(val) {
            if (val) {
                this.is_changed = false;
                this.value = "";
                this.$emit("update:resetting", false);
            }
        },
        isShowSuggestions(val) {
            this.wasSelected = false;
            if (!val) {
                setTimeout(() => {
                    this.$refs.input.blur();
                    this.is_focus = false;
                }, 100);
            }
        },
        country() {
            if (this.initValue == "") {
                this.$emit("reset");
                this.$emit("reset");
                this.suggestions = [];
                this.is_changed = false;
                this.value = "";
            }
        },
        isFocus(val) {
            if (val) {
                this.$emit("focus");
            } else {
                this.$emit("blur");
            }
        },
        initValue(val) {
            if (val) {
                this.value = this.initValue;
                this.is_changed = true;
            }
        },
    },
    methods: {
        setWasSelected(value) {
            this.wasSelected = value;
        },
        checkValue() {
            if (this.initValue == "") {
                var obj = this;
                setTimeout(function () {
                    if (!obj.wasSelected) {
                        obj.value = "";
                        obj.is_focus = false;
                    }
                }, 200);
            }
        },
        get(e) {
            this.options.query = e.target.value;
            this.query = e.target.value;
            if (this.options.query) {
                this.is_changed = true;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.$axios.post("/api/dadata/suggest/address", this.options).then((res_dadata) => {
                        this.suggestions = res_dadata.data.suggestions.filter((s) => s.data.postal_code);
                        if (!this.$device.isDesktop) {
                            try {
                                this.$refs.input.scrollIntoView({ block: "top", behavior: "smooth" });
                            } catch (err) {
                                console.log(err);
                            }
                        }
                    });
                }, 300);
            } else {
                this.is_changed = false;
                this.suggestions.length = 0;
                this.$emit("reset");
            }
        },
        select(data) {
            console.log(`select data =>`, data);
            this.$emit("update:isCityPreload", true);
            this.is_focus = false;
            this.value = data.city || data.data.city || data.data.settlement;
            this.wasSelected = true;
            let requestCountry = this.country ? this.country : this.defaultCountry;
            this.$axios
                .get(
                    `/api/geohelper/cities?apiKey=WnTr3BOnnSO4LoOAYXT1lKvAcKclCsg7&filter[countryIso]=${requestCountry}&locale[lang]=${
                        this.langust
                    }&pagination[limit]=1${
                        requestCountry == "RU"
                            ? "&filter[externalIds][fias][]=" + (data.data.fias_id || data.data.city_fias_id)
                            : ""
                    }`
                )
                .then((res_geohelper) => {
                    const ghr = res_geohelper.data.result[0];
                    const city_data = data;
                    city_data.geohelper = ghr;
                    city_data.city = `${ghr.localityType.localizedNamesShort.ru} ${ghr.localizedNames.ru}`;
                    city_data.zip = data.data.postal_code;
                    this.$emit("update:isCityPreload", false);
                    this.$emit("select", city_data);
                });
        },
    },
    mounted() {
        if (this.initValue) {
            this.value = this.initValue;
            this.is_changed = true;
        }
    },
};
</script>
<style lang="less">
.dadata-suggestions {
    position: relative;
    &.is_changed {
        .form-group__input {
            padding-right: 10px;
        }
    }
    .form-group__input {
        text-overflow: ellipsis;
        text-align: left;
    }
    &__list {
        position: absolute;
        top: 100%;
        z-index: 11;
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid @border2;
        margin-top: -1px;
        padding: 16px 0;
        &.is_empty {
            &:before {
                content: "Город не найден";
                padding: 8px 24px;
                color: @text_3;
                [langg]:not([langg="ru"]) & {
                    content: "Town not found";
                }
            }
        }
    }
    &__item {
        cursor: pointer;
        color: @text_3;
        padding: 8px 24px;
        .trs(color);
        mark {
            color: #000;
            background: none;
        }
        &:hover {
            background-color: #f9f9f9;
        }
    }
}
</style>
